module.exports = __webpack_public_path__ + "media/images/img1-ecd76f46190885777a28dc547988d266.png";